import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Tab, Tabs, Spinner } from "react-bootstrap";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import { Bell, Lock, Mail, User } from "lucide-react";
import Navbar from "../../../components/user/navbar/Navbar";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";

const SettingInCustomer = () => {
  const { baseUrl, loggedInCustomer } = useContext(AppContext);
  const [idToUpdate, setIdToUpdate] = useState("");
  const [key, setKey] = useState("profile");
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [notificationSettings, setNotificationSettings] = useState({
    appNotification: true,
    emailNotification: false,
  });

  const toggleNotification = (field) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const viewCustomerProfile = () => {
    axios
      .get(`${baseUrl}/customer/setting/viewCustomerprofile`)
      .then((response) => {
        const data = response.data.customer;
        resetForm();

        setIdToUpdate(data.id);

        // profile data
        setFullname(data.fullname);
        setEmail(data.email);
        setPhone(data.phone);

        // notification data
        setNotificationSettings({
          appNotification: data.app_notification === 1,

          emailNotification: data.email_notification === 1,
        });
      })
      .catch((error) => {
        console.log(error.response?.data);
      });
  };
  const updateProfile = () => {
    console.log(
      "log from the update profile function",
      idToUpdate,
      fullname,
      email,
      phone,
      currentPassword,
      newPassword,
    );
    if (newPassword && newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Password not matched",
      });

      return;
    }

    setUpdateProfileLoading(true);

    const formData = new FormData();

    formData.append("id", idToUpdate);

    formData.append("fullname", fullname);

    formData.append("phone", phone);

    // password fields
    // formData.append("current_password", currentPassword);

    // formData.append("new_password", newPassword);

    // formData.append("confirm_password", confirmPassword);

    axios
      .post(`${baseUrl}/customer/setting/updateProfile`, formData, {
        headers: {
          "Content-Type": "multipart/formData",
        },
      })
      .then((res) => {
        console.log("log from the response data", res.data);
        setUpdateProfileLoading(false);

        viewCustomerProfile();

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile updated successfully",
        });
      })
      .catch((error) => {
        console.log(error.response?.data);

        setUpdateProfileLoading(false);
      });
  };
  const changePassword = () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Password not matched",
      });

      return;
    }

    setChangePasswordLoading(true);

    const formData = new FormData();

    formData.append("id", idToUpdate);

    formData.append("current_password", currentPassword);

    formData.append("new_password", newPassword);

    formData.append("confirm_password", confirmPassword);

    axios
      .post(`${baseUrl}/customer/setting/changePassword`, formData)
      .then((res) => {
        setChangePasswordLoading(false);

        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");

        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
      })
      .catch((error) => {
        console.log(error.response?.data);

        setChangePasswordLoading(false);

        Swal.fire({
          icon: "error",
          title: "Oops",
          text: error.response?.data?.message,
        });
      });
  };
  const resetForm = () => {
    setFullname("");
    setEmail("");
    setPhone("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setIdToUpdate("");
  };
  useEffect(() => {
    console.log("useEffect called from the profile screen", loggedInCustomer);

    viewCustomerProfile();

    if (loggedInCustomer) {
      setFullname(loggedInCustomer?.fullname || "");

      setEmail(loggedInCustomer?.email || "");

      setPhone(loggedInCustomer?.phone || "");
    }
  }, [loggedInCustomer]);

  return (
    <Container fluid>
      <MarqueeBanner />
      <Navbar />

      <SimpleBanner
        title="Settings"
        subtitle=""
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "settings", href: "/customer-setting" },
        ]}
      />

      <div className="settings-wrapper">
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="settings-tabs"
        >
          {/* ================= PROFILE TAB ================= */}
          <Tab
            eventKey="profile"
            title={
              <span className="tab-title">
                <User size={16} /> Profile
              </span>
            }
          >
            <div className="settings-card">
              <h5>Profile Information</h5>

              <div className="settings-grid">
                <input
                  type="text"
                  placeholder="Full Name"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  disabled={true}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="text-end mt-4">
                <Button onClick={updateProfile} disabled={updateProfileLoading}>
                  {updateProfileLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Update Profile"
                  )}
                </Button>
              </div>
            </div>
          </Tab>

          {/* ================= PASSWORD TAB ================= */}
          <Tab
            eventKey="password"
            title={
              <span className="tab-title">
                <Lock size={16} /> Password
              </span>
            }
          >
            <div className="settings-card">
              <h5>Reset Password</h5>

              <div className="settings-grid">
                <input
                  type="password"
                  placeholder="Current Password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <div className="text-end mt-4">
                <Button
                  variant="danger"
                  onClick={changePassword}
                  disabled={changePasswordLoading}
                >
                  {changePasswordLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Reset Password"
                  )}
                </Button>
              </div>
            </div>
          </Tab>
          {/* ================= NOTIFICATIONS TAB ================= */}
          <Tab
            eventKey="notifications"
            title={
              <span className="tab-title">
                <Bell size={16} /> Notifications
              </span>
            }
          >
            <div className="settings-card">
              <h5>Notification Settings</h5>

              <div className="settings-row">
                <div className="setting-info">
                  <Bell size={18} />
                  <span>App Notification</span>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={notificationSettings.appNotification}
                    onChange={() => toggleNotification("appNotification")}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              <div className="settings-row">
                <div className="setting-info">
                  <Mail size={18} />
                  <span>Email Notification</span>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={notificationSettings.emailNotification}
                    onChange={() => toggleNotification("emailNotification")}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>

      <Footer />
    </Container>
  );
};

export default SettingInCustomer;
